const MODAL_ID = 'hubspot-revenue-projection-form-modal';

export function initLazyRevenueProjectionForm() {
    document.addEventListener('modal:open', (event) => {
        if (event.detail?.id !== MODAL_ID) return;

        const modal = event.target;
        const target = modal.querySelector(
            '[data-hubspot-revenue-projection-form]'
        );
        const template = modal.querySelector(
            '[data-hubspot-revenue-projection-template]'
        );
        const form = template?.content.firstElementChild;

        if (target && form) target.appendChild(form);
    });
}
